enum CreationToolFont {
    Giphy = 'CT_FONT_GIPHY',
    Meme = 'CT_FONT_MEME',
    Fancy = 'CT_FONT_FANCY',
    Pixel = 'CT_FONT_PIXEL',
    Subtitle = 'CT_FONT_SUBTITLE',
    Traditional = 'CT_FONT_TRADITIONAL',
    Custom = 'CT_FONT_CUSTOM',
}

namespace CreationToolFont {
    /**
     * Returns all available fonts (in order)
     */
    export function all(includeCustom = false): CreationToolFont[] {
        const allFonts = [
            CreationToolFont.Giphy,
            CreationToolFont.Meme,
            CreationToolFont.Fancy,
            CreationToolFont.Pixel,
            CreationToolFont.Subtitle,
            CreationToolFont.Traditional,
        ]
        if (includeCustom) {
            allFonts.push(CreationToolFont.Custom)
        }
        return allFonts
    }

    /**
     * Returns the font's display title.
     */
    export function title(font: CreationToolFont): string {
        switch (font) {
            case CreationToolFont.Giphy:
                return 'GIPHY'
            case CreationToolFont.Meme:
                return 'Meme'
            case CreationToolFont.Fancy:
                return 'Fancy'
            case CreationToolFont.Pixel:
                return 'Pixel'
            case CreationToolFont.Subtitle:
                return 'Subtitle'
            case CreationToolFont.Traditional:
                return 'Traditional'
            case CreationToolFont.Custom:
                return 'Custom Font'
        }
    }

    /**
     * Returns the font's css font-family name.
     */
    export function fontFamily(font: CreationToolFont): string {
        switch (font) {
            case CreationToolFont.Giphy:
                return `"nexablack"`
            case CreationToolFont.Meme:
                return `"meme"`
            case CreationToolFont.Fancy:
                return `"Brush Script MT", cursive`
            case CreationToolFont.Pixel:
                return `"emulogic"`
            case CreationToolFont.Subtitle:
            case CreationToolFont.Traditional:
                return `"interface"`
            case CreationToolFont.Custom:
                return 'customfont'
        }
    }

    /**
     * Returns the font's font-weight.
     */
    export function fontWeight(font: CreationToolFont): 'bold' | 'normal' {
        switch (font) {
            case CreationToolFont.Subtitle:
                return 'bold'
            default:
                return 'normal'
        }
    }

    /**
     * Returns whether or not the font should be in all caps.
     */
    export function isAllCaps(font: CreationToolFont): boolean {
        switch (font) {
            case CreationToolFont.Giphy:
            case CreationToolFont.Meme:
                return true
            default:
                return false
        }
    }

    /**
     * Returns the font's scale. This is used to normalize each font's size to be consistent.
     */
    export function scale(font: CreationToolFont): number {
        switch (font) {
            case CreationToolFont.Meme:
                return 1.2
            case CreationToolFont.Fancy:
                return 1.4
            case CreationToolFont.Pixel:
                return 0.7
            case CreationToolFont.Traditional:
                return 0.9
            default:
                return 1
        }
    }

    /**
     * Returns the font's file url.
     */
    export function url(font: CreationToolFont): string {
        switch (font) {
            case CreationToolFont.Giphy:
                return '/static/webfont/nexa_black-webfont.woff'
            case CreationToolFont.Meme:
                return '/static/webfont/meme.woff'
            case CreationToolFont.Pixel:
                return '/static/webfont/emulogic.woff'
            case CreationToolFont.Subtitle:
                return '/static/webfont/InterFace_W_Bd.woff'
            case CreationToolFont.Traditional:
                return '/static/webfont/InterFace_W_Rg.woff'
            default:
                return ''
        }
    }
}

export default CreationToolFont
